/**
 * Format a phone number as (XXX) XXX-XXXX, stripping country code.
 * Supports extensions: (XXX) XXX-XXXX ext 123
 * Returns original string if not parseable.
 */
export function formatPhoneNumber(raw: string | null | undefined): string {
  if (!raw) return '';
  
  const trimmed = raw.trim();
  if (!trimmed) return '';

  // Extract extension patterns like "ext 123", "x123", "ext. 123"
  const extMatch = trimmed.match(/(?:\s*(?:ext\.?|x)\s*(\d+))\s*$/i);
  const extension = extMatch ? extMatch[1] : '';
  const withoutExt = extMatch ? trimmed.slice(0, extMatch.index) : trimmed;

  // Strip non-digits
  const digits = withoutExt.replace(/\D/g, '');

  // Strip leading 1 (US country code) if 11 digits
  const core = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (core.length !== 10) return trimmed; // Can't parse, return original

  const formatted = `(${core.slice(0, 3)}) ${core.slice(3, 6)}-${core.slice(6)}`;
  return extension ? `${formatted} ext ${extension}` : formatted;
}
